export function EntityLogo({
  type,
  id,
  size = 20,
}: {
  type: "corp" | "alliance";
  id: number;
  size?: number;
}) {
  const path = type === "corp" ? "corporations" : "alliances";
  return (
    <img
      className="entity-logo"
      src={`https://images.evetech.net/${path}/${id}/logo?size=64`}
      width={size}
      height={size}
      alt=""
    />
  );
}
